import React from "react";
import { Route, Routes } from "react-router-dom";

import MainLayout from "../Layout/MainLayout";
import Home from "../Pages/Home";
import SecondaryEngipi from "../Pages/SecondaryEngipi";
import Page360 from "../Pages/Page360";
import Blog from "../Pages/Blog";
import BlogPost from "../Pages/BlogPost";
import Login from "../Pages/Login";
import Admin from "../Pages/Admin";
import AdminPostForm from "../Pages/AdminPostForm";
import MemberDashboard from "../Pages/MemberDashboard";
import ProtectedRoute from "./ProtectedRoute";

export default function AppRoutes() {
  return (
    <Routes>
      {/* Public pages inside main layout */}
      <Route path="/" element={<MainLayout />}>
        <Route index element={<Home />} />
        <Route path="SecondaryEngipi" element={<SecondaryEngipi />} />
        <Route path="Page360" element={<Page360 />} />
        <Route path="blog" element={<Blog />} />
        <Route path="blog/:slug" element={<BlogPost />} />
      </Route>

      {/* Auth */}
      <Route path="/login" element={<Login />} />

      {/* Member dashboard - any authenticated user */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <MemberDashboard />
          </ProtectedRoute>
        }
      />

      {/* Admin - protected, no layout wrapper */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute role="admin">
            <Admin />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/posts/new"
        element={
          <ProtectedRoute role="admin">
            <AdminPostForm />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/posts/:id/edit"
        element={
          <ProtectedRoute role="admin">
            <AdminPostForm />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
